import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AutomationState } from "../states/automation.state";

export const selectAutomationState =
  createFeatureSelector<AutomationState>("automation");

export const selectApplications = (automationProjectId: string) =>
  createSelector(
    selectAutomationState,
    (state) => state.applications[automationProjectId] ?? []
  );

export const selectAllApplications = createSelector(
  selectAutomationState,
  (state) => state.applications
);

export const selectPages = (applicationId: string) =>
  createSelector(
    selectAutomationState,
    (state) => state.pages[applicationId] ?? []
  );

export const selectAllPages = createSelector(
  selectAutomationState,
  (state) => state.pages
);

export const selectApplcationsAndPages = createSelector(
  selectAllApplications,
  selectAllPages,
  (applications: any, pages: any) => {
    return {
      applications,
      pages,
    };
  }
);

export const selectUiObjects = (pageId: string) =>
  createSelector(
    selectAutomationState,
    (state) => state.uiObjects[pageId] ?? []
  );

export const selectScriptGroup = createSelector(
  selectAutomationState,
  (state) => state.scriptGroup
);

export const selectTestScript = createSelector(
  selectAutomationState,
  (state) => state.testScript
);

export const selectCombinedTestSuiteComponent = createSelector(
  selectScriptGroup,
  selectTestScript,
  (testSuites, testcases) => {
    return {
      testSuites,
      testcases,
    };
  }
);

export const selectReusableComponent = createSelector(
  selectAutomationState,
  (state) => state.reusableComponent
);

export const selectReusableScript = createSelector(
  selectAutomationState,
  (state) => state.reusableScript
);

export const selectCombinedReusableComponent = createSelector(
  selectReusableComponent,
  selectReusableScript,
  (reusableComponent, reusableScript) => {
    return {
      reusableComponent,
      reusableScript,
    };
  }
);

export const selectCommandDefinitions = createSelector(
  selectAutomationState,
  (state) => state.commandDefinitions
);
export const selectLoading = createSelector(
  selectAutomationState,
  (state) => state.loading
);
export const selectAutomationError = createSelector(
  selectAutomationState,
  (state) => state.error
);

export const selectAllServices = createSelector(
  selectAutomationState,
  (state) => state.apiServices
);

export const selectServiceLoading = createSelector(
  selectAutomationState,
  (state) => state.loading
);


export const selectAllServiceOperations =createSelector(
  selectAutomationState,
  (state) => state.serviceOperations
);

export const selectServiceOperationLoading = createSelector(
  selectAutomationState,
  (state) => state.loading
);

export const selectOperationParameters =createSelector(
  selectAutomationState,
  (state) => state.operationParameters
);

export const selectOperationHeaders =createSelector(
  selectAutomationState,
  (state) => state.operationHeaders
);


export const selectOperationParametersLoading = createSelector(
  selectAutomationState,
  (state) => state.loading
);